import { Input, Label } from 'components/atoms';
import { IChannelVideoResponse } from 'services/channel/types/query';
import { PiEye, PiThumbsDown, PiThumbsUp, PiPlay } from 'react-icons/pi';

interface IVideoCardProps {
  video: IChannelVideoResponse;
  isSelected: boolean;
  onToggle: () => void;
}

const VideoCard = ({ video, isSelected, onToggle }: IVideoCardProps) => {
  return (
    <div
      className={`rounded-lg p-4 cursor-pointer transition-all`}
      onClick={onToggle}>
      <div className='flex gap-3'>
        <div
          className='flex-shrink-0 pt-1'
          onClick={e => {
            e.stopPropagation();
            onToggle();
          }}>
          <Input.Checkbox
            name={`video-${video.id}`}
            checked={isSelected}
            onChange={e => {
              e.stopPropagation();
              onToggle();
            }}
          />
        </div>

        <div className='flex-1 flex gap-3 items-center'>
          <img
            src={video.videoImageLink}
            alt={video.videoTitle}
            className='w-16 h-12 object-cover rounded-sm'
          />

          <div className='flex-1 flex flex-col gap-2'>
            <div className='text-gray-500 break-words'>   
              {video.videoTitle}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;

